import { blue, deepPurple } from "@mui/material/colors";
import type { DataCollectionSubmissionStatus } from "../../api/dataCollectionTypes";
import type { ThemeColorFn } from "../../utilities/colorHelper";
import { makeModeAwareAccent } from "../../utilities/colorHelper";
import { dataSubmissionStatusCaptionsMap } from "../../utilities/enumCaptions";
import StatusChip from "../StatusChip";

interface Props {
  status: DataCollectionSubmissionStatus;
}

const colorsMaps: Record<DataCollectionSubmissionStatus, ThemeColorFn> = {
  Draft: (t) => t.palette.text.secondary,
  Pending: (t) => makeModeAwareAccent(t, blue),
  Scheduled: (t) => makeModeAwareAccent(t, deepPurple),
  Completed: (t) => t.palette.success.main,
};

const DataSubmissionStatusTag = ({ status }: Props) => {
  return <StatusChip label={dataSubmissionStatusCaptionsMap[status] ?? status} withDot color={colorsMaps[status]} />;
};

export default DataSubmissionStatusTag;
